import { useState } from "react";
import { useTranslation } from "react-i18next";
import * as api from "../../../../lib/claimsApi.ts";
import { logMetricEvent } from "../../../../lib/delivery";
import { MetricEvents } from "@shared/integrations/delivery_keys";

interface UseShareButtonResult {
  open: boolean;
  handleShare: () => Promise<void>;
  handleClose: () => void;
}

export function useShareButton(claimId?: string): UseShareButtonResult {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  async function handleShare() {
    const url = window.location.href;
    if (navigator.share) {
      try {
        await navigator.share({ url, title: t("share.shareTitle") });
        if (claimId) api.trackEvent("share", claimId).catch(() => {});
        logMetricEvent(MetricEvents.platformVerificationShared, { metadata: { method: "native" } });
        return;
      } catch {
        // user cancelled — fall through to clipboard
      }
    }
    await navigator.clipboard.writeText(url).catch(
      // Catch rare cases of:
      // "Failed to execute 'writeText' on 'Clipboard': Document is not focused."
      () => {}
    );
    if (claimId) api.trackEvent("share", claimId).catch(() => {});
    logMetricEvent(MetricEvents.platformVerificationShared, { metadata: { method: "clipboard" } });
    setOpen(true);
  }

  function handleClose() {
    setOpen(false);
  }

  return { open, handleShare, handleClose };
}
